import { render, staticRenderFns } from "./totalEnterprises.vue?vue&type=template&id=0db8b0de&"
import script from "./totalEnterprises.vue?vue&type=script&lang=js&"
export * from "./totalEnterprises.vue?vue&type=script&lang=js&"
import style0 from "./totalEnterprises.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports